// src/pages/BillingSuccess.jsx
import React, { useEffect } from "react";
import { useAuth } from "@clerk/clerk-react";
import axios from "axios";
import { useCreditStore } from "../store/useCreditStore";
import { useNavigate } from "react-router-dom";

export default function BillingSuccess() {
  const { getToken } = useAuth();
  const { setCredits } = useCreditStore();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCredits = async () => {
      try {
        const token = await getToken();
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/credits`,
          {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true,
          }
        );
        setCredits(res.data?.credits ?? 0);

        // redirect after 2 seconds to generate
        setTimeout(() => navigate("/generate"), 2000);
      } catch (err) {
        console.error("Failed to refresh credits:", err);
        // fallback: redirect anyway
        setTimeout(() => navigate("/generate"), 2000);
      }
    };

    fetchCredits();
  }, [getToken, setCredits, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0F0F1B] via-[#121225] to-[#15152B] px-4">
      <div className="w-full max-w-md rounded-3xl border border-[#FC2783]/40 bg-[#15152B]/90 shadow-[0_0_60px_rgba(252,39,131,0.35)] p-8 text-center">
        <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-emerald-400/40 bg-emerald-400/10 px-4 py-1 text-xs font-medium uppercase tracking-[0.16em] text-emerald-300">
          <span className="h-2 w-2 rounded-full bg-emerald-400 animate-pulse" />
          Payment confirmed
        </div>

        <div className="mb-4 text-5xl">🎉</div>

        <h1 className="text-2xl font-semibold text-white mb-2">
          Payment Successful
        </h1>

        <p className="text-sm text-gray-300 mb-1">
          Finalising your purchase&hellip;
        </p>
        <p className="text-xs text-gray-400">
          You&apos;ll be redirected to the{" "}
          <span className="font-medium text-[#FC2783]">Generate</span> page in a
          moment.
        </p>

        <div className="mt-6 h-px w-16 mx-auto bg-gradient-to-r from-transparent via-[#FC2783] to-transparent" />

        <p className="mt-4 text-[11px] text-gray-500">
          If nothing happens, you can safely close this tab and reopen the app from{" "}
          <span className="font-medium text-gray-300">pixelads.ai</span>.
        </p>
      </div>
    </div>
  );
}
